module.exports = __webpack_public_path__ + "img/words.8f9e6f5d.svg";